<template>
  <div class="container">
    <div class="row justify-content-center mt-3">
      <b-card header="Login" class="col-md-5 p-0 mt-3">
        <b-form @submit.prevent="submit">
          <b-form-group label="UserName">
            <b-form-input ref="name" v-model="loginForm.username" trim></b-form-input>
          </b-form-group>
          <b-form-group label="Password">
            <b-form-input ref="pass" v-model="loginForm.password" trim type="password"></b-form-input>
          </b-form-group>
          <b-button
            variant="primary"
            type="submit"
            :disabled="loading"
          >{{loading?"loading...":"LOGIN"}}</b-button>
        </b-form>
      </b-card>
    </div>
  </div>
</template>
<script>
export default {
  computed: {},
  data() {
    return {
      loginForm: {
        username: "",
        password: ""
      },
      loading: false
    };
  },
  methods: {
    submit: function() {
      if (!(this.loginForm.username && this.loginForm.password))
        return this.$message("账号或密码为空!", "d");
      let _this = this;
      this.loading = true;
      this.common.axios
        .post("./admin/public/login", this.loginForm)
        .then(() => {
          this.loading = false;
          _this.$message("登录成功", "i");
          window.localStorage.setItem(
            "loginTime",
            new Date().valueOf() + 300000
          );
          _this.$store.commit("loginSuccess");
          _this.$router.push({ path: "/dashboard" });
        })
        .catch(e => {
          this.loading = false;
          if (e.response) _this.$message(e.response.data.info, "d");
          else _this.$message(e.message, "d");
        });
    }
  }
};
</script>